webpackJsonp([23],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(743),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cant-access',
  props: ['token'],
  data: function data() {
    var _this = this;

    return {
      dialogCantAccess: false,
      loading: false,
      form: false,
      rules: {
        name: [function (v) {
          return !!v || 'Nome em branco';
        }, function (v) {
          return v.length > 2 || 'Precisa conter no minimo 3 caracteres';
        }],
        document: [function (v) {
          return !!v || 'Documento em branco';
        }, function (v) {
          return _this.validaDocumento(v) || 'Documento inválido';
        }],
        phone: [function (v) {
          return !/[^0-9()-\W]{1,15}/.test(v) || 'Telefone inválido';
        }, function (v) {
          return !!v || 'Telefone em branco';
        }, function (v) {
          return v.length < 12 || 'Telefone inválido';
        }, function (v) {
          return v.length > 9 || 'Telefone inválido';
        }],
        email: [function (v) {
          return !!v || 'Email em branco';
        }, function (v) {
          return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'Email inválido'
          );
        }]
      }
    };
  },

  methods: {
    updateName: function updateName(value) {
      this.$store.commit('cantAccess/updateName', value);
    },
    updateDocument: function updateDocument(value) {
      this.$store.commit('cantAccess/updateDocument', value);
    },
    updatePhone: function updatePhone(value) {
      this.$store.commit('cantAccess/updatePhone', value);
    },
    updateEmail: function updateEmail(value) {
      this.$store.commit('cantAccess/updateEmail', value);
    },
    sendCantAccess: function sendCantAccess() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        this.$store.dispatch('cantAccess/sendEmail', this.token).then(function () {
          _this2.dialogCantAccess = false;
          _this2.$store.commit('toastr', {
            color: 'success',
            texto: 'email enviado com sucesso'
          });
        });
      }
    },

    validaDocumento: function validaDocumento(numero) {
      numero = numero.replace(/\D/g, '');
      if (numero.length === 11) {
        var cpf = numero;
        var Soma = 0;
        var Resto = 0;
        if (cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
          return false;
        }
        for (var i = 1; i <= 9; i++) {
          Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        Resto = Soma * 10 % 11;

        if (Resto === 10 || Resto === 11) {
          Resto = 0;
        }
        if (Resto !== parseInt(cpf.substring(9, 10))) {
          return false;
        }
        Soma = 0;
        for (var _i = 1; _i <= 10; _i++) {
          Soma = Soma + parseInt(cpf.substring(_i - 1, _i)) * (12 - _i);
        }
        Resto = Soma * 10 % 11;
        if (Resto === 10 || Resto === 11) {
          Resto = 0;
        }
        if (Resto !== parseInt(cpf.substring(10, 11))) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    cantAccess: function cantAccess() {
      return this.$store.getters['cantAccess/state'];
    }
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CantAccess__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CantAccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CantAccess__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'check-in',
  props: ['token'],
  components: {
    CantAccess: __WEBPACK_IMPORTED_MODULE_0__CantAccess___default.a
  },
  computed: {
    email: function email() {
      return this.$store.getters.email;
    },
    loadingEmail: function loadingEmail() {
      return this.$store.getters.loadingEmail;
    }
  },
  methods: {
    updateEmail: function updateEmail(value) {
      this.$store.commit('updateEmail', value);
    },
    checkEmail: function checkEmail() {
      this.$store.dispatch('checkEmail', this.token);
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getCupom', this.token);
  }
});

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".modal-header{font-size:22px!important;font-weight:400;line-height:32px!important;letter-spacing:normal!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/CantAccess.vue"],"names":[],"mappings":"AACA,cACE,yBAA2B,AAC3B,gBAAiB,AACjB,2BAA6B,AAC7B,+BAAkC,CACnC","file":"CantAccess.vue","sourcesContent":["\n.modal-header{\n  font-size: 22px !important;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Checkin.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("c472dac6", content, true, {});

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("15311dd0", content, true, {});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(731),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "320px"
    },
    model: {
      value: (_vm.dialogCantAccess),
      callback: function($$v) {
        _vm.dialogCantAccess = $$v
      },
      expression: "dialogCantAccess"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "modal-header"
  }, [_vm._v("Dificuldades no acesso?")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogCantAccess = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "info-hotsite"
  }, [_vm._v("Para concluir a solicitação, é necessário ter e-mail de acesso ao portal de serviços da administradora do seu condomínio. Caso não tenha este e-mail, preeencha os campos abaixo e entraremos em contato.")])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "name": "form-cadastro"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Completo",
      "value": _vm.cantAccess.name,
      "validate-on-blur": true,
      "rules": _vm.rules.name
    },
    on: {
      "input": _vm.updateName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Documento (CPF)",
      "mask": "###-###-###-##",
      "value": _vm.cantAccess.document,
      "rules": _vm.rules.document,
      "validate-on-blur": true
    },
    on: {
      "input": _vm.updateDocument
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone",
      "mask": _vm.cantAccess.phone === 11 ? '(##) #####-####' : '(##) ####-#####',
      "value": _vm.cantAccess.phone,
      "rules": _vm.rules.phone,
      "validate-on-blur": true
    },
    on: {
      "input": _vm.updatePhone
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "rules": _vm.rules.email,
      "value": _vm.cantAccess.email,
      "validate-on-blur": true
    },
    on: {
      "input": _vm.updateEmail
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "loading": _vm.cantAccess.loading,
      "disabled": _vm.cantAccess.loading,
      "block": ""
    },
    on: {
      "click": _vm.sendCantAccess
    }
  }, [_vm._v("\n        enviar\n        "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center info-hotsite"
  }, [_vm._v("\n    Digite abaixo o seu e-mail de acesso ao portal da administradora do seu condomínio.\n  ")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkEmail($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu e-mail",
      "append-icon": "email",
      "value": _vm.email
    },
    on: {
      "input": _vm.updateEmail
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "loading": _vm.loadingEmail,
      "disabled": _vm.loadingEmail,
      "block": ""
    },
    on: {
      "click": _vm.checkEmail
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n    Acessar\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]), _vm._v(" "), _c('cant-access', {
    attrs: {
      "token": _vm.token
    }
  }, [_c('v-btn', {
    staticClass: "btn-hotsite-gray",
    attrs: {
      "large": "",
      "block": ""
    }
  }, [_vm._v("\n    Não estou conseguindo acessar\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/23.edfbbdd8e3080d792ca4.js